"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ScrollDepth;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useScrollPos = require("../../common/hooks/useScrollPos");
var _utils = require("./utils");
var _core = require("@emotion/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var pushed = [];
var checkScrollDepth = function checkScrollDepth(marks, scrollDepth, range) {
  marks.forEach(function (mark) {
    // push to gtm if it has not already been pushed for the page
    if (!pushed.includes(mark) && (scrollDepth >= mark || Math.abs(mark - scrollDepth) < range)) {
      (0, _utils.pushEvent)(mark);
      pushed.push(mark);
    }
  });
};
function ScrollDepth(_ref) {
  var path = _ref.path,
    _ref$range = _ref.range,
    range = _ref$range === void 0 ? 15 : _ref$range,
    children = _ref.children,
    _ref$throttle = _ref.throttle,
    throttle = _ref$throttle === void 0 ? 300 : _ref$throttle,
    _ref$scrollDepths = _ref.scrollDepths,
    scrollDepths = _ref$scrollDepths === void 0 ? [25, 50, 75, 100] : _ref$scrollDepths;
  (0, _useScrollPos.useScrollPos)(function (_ref2) {
    var currPos = _ref2.currPos;
    var height = document.documentElement.scrollHeight;
    var depth;
    if (currPos.y === 0) {
      depth = currPos.y;
    } else {
      depth = document.documentElement.clientHeight + currPos.y;
    } // find the nearest round value of scroll depth;

    var trueDepth = Math.floor(depth / height * 100);
    checkScrollDepth(scrollDepths, trueDepth, range);
  }, undefined, false, true, throttle); // reset on history change

  (0, _react.useEffect)(function () {
    pushed = [];
  }, [path]);
  return (0, _core.jsx)("div", null, children);
}
ScrollDepth.propTypes = {
  /** current active path */
  path: _propTypes["default"].string,
  /** how eagerly should we be updating the depths */
  range: _propTypes["default"].number,
  /** children of this component, this should ideally be a top level component, for future compatibility*/
  children: _propTypes["default"].node,
  /** list of numbers at which to trigger the scroll depth event*/
  scrollDepths: _propTypes["default"].array,
  /** throttle time */
  throttle: _propTypes["default"].number
};